import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import utils from '../utils'
const { $ } = utils

@inject('carInfo')
@observer
export default class CarSel extends Component {
  render(){
    let { carInfo } = this.props,{ isShow, hide } = carInfo,
    modalClass = isShow?'ath-tier-modal ath-tier-modal--hide ath-tier-modal--active':'ath-tier-modal ath-tier-modal--hide'

    return(
      <div className={ modalClass } id="JS-brandWrap">
        <div className="ath-tier-modal__stair">
          <div className="ath-tier-modal__header">
            <p className="ath-tier-modal__title">选择品牌</p>
            <a href="" className="ath-tier-modal__return" onClick={hide}>
              <i className="ath-icon ath-icon-arrowleft"></i>
            </a>
          </div>
          <div className="ath-tier-modal__stair-wrapper" id='JS-brandScroll'>
            <div className="ath-tier-modal__list">
              <ul className="ath-tier-modal__group" id="JS-brandList"></ul>
            </div>
          </div>
          <div className="min-letter-list" id="js-letter-list"></div>
        </div>
        <div className="ath-half-modal ath-half-modal--hide" id="JS-seriesWrap">
          <div className="ath-half-modal__shadow"></div>
          <div className="ath-half-modal__wrapper">
            <div className="ath-tier-modal__header">
              <p className="ath-tier-modal__title">选择车系</p>
              <a href="" className="ath-tier-modal__return">
                <i className="ath-icon ath-icon-arrowleft"></i>
              </a>
            </div>
            <div className="ath-half-modal__list">
              <ul className="ath-half-modal__group" id="JS-seriesList"></ul>
            </div>
          </div>
        </div>
        <div className="ath-half-modal ath-half-modal--hide" id="JS-specWrap">
          <div className="ath-half-modal__shadow"></div>
          <div className="ath-half-modal__wrapper">
            <div className="ath-tier-modal__header">
              <p className="ath-tier-modal__title">选择车型</p>
              <a href="" className="ath-tier-modal__return">
                <i className="ath-icon ath-icon-arrowleft"></i>
              </a>
            </div>
            <div className="ath-half-modal__list">
              <ul className="ath-half-modal__group" id="JS-specList"></ul>
            </div>
          </div>
        </div>
      </div>
    )
  }
  componentDidMount(){
    let { carInfo } = this.props,{ hide, changeCar } = carInfo

    let selCarRes

		//车型选择
    var $brandsModal = $("#JS-brandWrap"),
      $seriesModal = $("#JS-seriesWrap"),
  
      $brandList = $("#JS-brandList"),
      $seriesList = $("#JS-seriesList"),
  
      brandId,brandName,
      seriesId,seriesName,
      letterArr = []

    // ios兼容
    $('#js-letter-list').css('height',$(window).height()*0.8 + 'px')

    //返回关闭
    $(".ath-tier-modal__return").on("touch click",function(){
      $(this).parent().parent().parent().removeClass("ath-tier-modal--active").removeClass("ath-half-modal--active")
    })
    //空白关闭
    $(".ath-half-modal__shadow").on("touch click",function(){
      $(this).parent().removeClass("ath-half-modal--active")
    })
  
    /**
     * 初始化品牌列表
     */
    function initBrand(cb){
      $.ajax({
        url: "//api.mall.autohome.com.cn/gateway/groupcars/getAllBrands?_appid=mall",
        dataType: "jsonp",
        cache: true,
        success: function(data){
          if(data.returncode === 0){
            var res = data.result
            if(res.brandlist){
              $brandList.empty()
              $('#js-letter-list').empty()
              res.brandlist.map(function(group,index){
                var brandTap = $('<li class="ath-tier-modal__tap ath-tier-modal__tap--gray" id="jump-'+group.letter+'">'+group.letter+'</li>')
                $brandList.append(brandTap)
                letterArr.push(group.letter)

                group.list.map(function(item,index){
                  var brandItem = $('<li class="ath-tier-modal__special-item">'+item.name+'</li>').data({
                    'id': item.id
                  })
                  $brandList.append(brandItem)
                })
              })

              letterArr.map(function(letter,index){
                var letterItem = $('<a class="min-letter-item" href="javascript:;">'+letter+'</a>')
                $('#js-letter-list').append(letterItem)
              })
              cb && cb()
            }
          }
        }
      })
    }

    /**
     * 渲染车系列表
     * @param id 品牌id
     */
    function renderSeries(id){
      $seriesList.html('<li class="ath-tier-modal__tap ath-tier-modal__tap--gray">'+brandName+'</li>')
      $.ajax({
        url: "//api.mall.autohome.com.cn/gateway/groupcars/getSeriesByBrand?_appid=mall&brandId="+id,
        dataType: "jsonp",
        cache: true,
        success: function(data){
          if(data.returncode === 0){
            data.result.fctlist.map(function(fct,index){
              fct.serieslist.map(function(series,index){
                var seriesItem =
                $('<li class="ath-tier-modal__item ath-tier-modal__item--higher">'+series.name+'</li>').data({
                  id: series.id
                })
                $seriesList.append(seriesItem)
              })
            })
          }
        }
      })
    }
  
    //点选品牌
    $brandList.on("touch click",".ath-tier-modal__special-item",function(){
      brandId = $(this).data("id")
      brandName = $(this).html()
      $seriesModal.addClass("ath-half-modal--active")
      renderSeries(brandId)
    })
    //点选车系
    $seriesList.on("touch click",".ath-tier-modal__item--higher",function(){
      seriesId = $(this).data("id")
      seriesName = $(this).html()
      
      $brandsModal.removeClass('ath-tier-modal--active')
      $seriesModal.removeClass('ath-half-modal--active')
  
      selCarRes = {
        brandId: brandId,
        brandName: brandName,
        seriesId: seriesId,
        seriesName: seriesName
      }

      changeCar(selCarRes)
      hide()
    })
  
    initBrand(function(){
      document.getElementById('js-letter-list').addEventListener('touchstart', handleTouchStart)
    })

    /**
     * 品牌字母滑动定位
    */
    var scrollEl = $('#JS-brandScroll')

    function handleTouchStart(e) {
      scrollEl.css('overflow-y', 'hidden')
      scrollList(e,false)

      window.addEventListener('touchmove', handleTouchMove)
      window.addEventListener('touchend', handleTouchEnd)
    }
    function scrollList(e,move) {
      if(!move) scrollEl.css('overflow-y', 'hidden')
      var targetDOM,target,x,y,currentItem
      // 手指移动，根据坐标定位
      if(move) {
        x = e.changedTouches[0].clientX
        y = e.changedTouches[0].clientY

        currentItem = document.elementFromPoint(x, y)
        // if (!currentItem || cache.text == currentItem.innerText || !currentItem.classList.contains('min-letter-item')) {
        //   return
        // }
        // cache.text = currentItem.innerText
        // cache.x = x
        // cache.y = y
        if (!currentItem || !currentItem.classList.contains('min-letter-item')) {
          return
        }
        target = currentItem.innerText
      }else {
        // 点击获取目标元素
        target = e.target.innerText
      }

      //console.log(target)
      //console.log(move)

      // 触摸到的是字母
      if (target.length === 1) {
        targetDOM = document.getElementById('jump-'+target)
        // var scrollTop = scrollEl.scrollTop()
        // var top = $('#jump-'+target).offset().top
        var top = $('#jump-'+target)[0].offsetTop - 45
        // var contscrollTop = scrollTop + top - 40
        // var st = targetDOM.getBoundingClientRect().top

        if(!move) scrollEl.css('overflow-y', 'auto')

        if (target === 'A') {
          scrollEl.scrollTop(0)
        } else {
          // scrollEl.scrollTop(contscrollTop)
          scrollEl.scrollTop(top)
          //console.log(contscrollTop)
          //console.log(scrollEl.scrollTop())
        }
      }
      
      e.preventDefault()
    }
    function handleTouchMove(e) {
      scrollList(e,true)
    }
    function handleTouchEnd() {
      scrollEl.css('overflow-y', 'auto')
      window.removeEventListener('touchmove', handleTouchMove)
      window.removeEventListener('touchend', handleTouchEnd)
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/CarSel.js